import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Lowarrow from "../../../asset/images/low-arrow.svg";
import UpArrow from "../../../asset/images/up-arrow.svg";
import { Constants } from "../../../CommonMethhods/Constants";
import {
  forToFix,
  numDifferentiation,
  numDifferentiationWithoutSymbol,
} from "../../../CommonMethhods/CovertRupees";
import { DASHBOARD_DEFAULT } from "../../../Configuration/API_URL";
import {
  AESEncryption,
  ApiResDecrypt,
  checkEmpty,
  getTabStatus,
  goToClientDashboard,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { duration } from "moment/moment";
import Loader from "../../Common/Loader";
import SmallLoader from "../../Common/smallLoader";
import LoaderForSearch from "../../Common/LoaderForSearch";
import Form from "react-bootstrap/Form";
import backIcon from "../../../asset/images/arrow-backicon.svg";
import arrow from "../../../asset/images/orange-arrow.svg";
import addCircle from "../../../asset/images/add-circle.svg";
import minusCircle from "../../../asset/images/minus-circle.svg";
import { toast } from "react-toastify";
import axios from "axios";


function AumSnapshot(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [loader, setLoader] = useState(true);
  const revenueTable = props.revenueTableData;
  const [duration, setDuration] = useState("");
  const [aumEquModel, setAumEquModel] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [segment, setSegment] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const title = props.title.split(" ")[0];
  const firstColumnTitle = title === "Sales" ? "Turnover" : title;
  const setShowAumModal = props.setShowAumModal;
  const modalDuration = props.modalDuration;
  const setModalDuration = props?.setModalDuration;
  const aumLoader = props?.aumLoader;
  const [aumMfData, setAumMfData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [clCodeMf, setClCodeMf] = useState("");
  const [mfPage, setMfPage] = useState(1);
  const [mfLoader, setMfLoader] = useState(false)

  const rowLabels = [
    "Equity",
    // "PMS",
    "Mutual Funds",
    "Total",
  ];

  const handleifTableEmpty = (flag) => {
    const tempArray = [
      [0, 0, 0, 0],
      // [0, 0, 0, 0],
      [0, 0, 0, 0],
      [0, 0, 0, 0],
    ];

    return tempArray.map((column, index) => {
      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {flag === true ? (
            <th className="text-left first-col">{rowLabels[index]}</th>
          ) : (
            <></>
          )}
          {column.map((index) => {
            return (
              <td key={index} className="snapshot-table-columns">
                {"0"}
              </td>
            );
          })}
        </tr>
      );
    });
  };

  const getAumSnapshotEquityModel = async (
    duration,
    segment,
    pageNo,
    fileData = "grid",
    pageSize = 10,
  ) => {
    if (fileData == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else if (fileData == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      pageSize: pageSize,
      pageNo,
      duration: duration,
      fileType: fileData,
      segment: segment,
    };
    let encPayload = AESEncryption(payloadValue);
    //let encPayload = payloadValue;

    try {
      const getAumEquity = await axios.post(
        DASHBOARD_DEFAULT.AUMSnapshotEquityModel_URL,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
        //encPayload,
        
      );
      const response = ApiResDecrypt(getAumEquity?.data);
      //const response = getAumEquity?.data;
      const res = response;
      if (res?.status === 0) {
        if (showModal == true) {
          if (fileData == "grid") {
            setAumEquModel((prev) => {
              return [...prev, ...res?.data?.holdList];
            });
          } else if (fileData == "pdf") {
            window.open(res?.data, "_blank", "noopener,noreferrer");
          } else {
            window.open(res?.data, "_self", "noopener,noreferrer");
          }
        } else {
          setAumEquModel(res?.data?.holdList);
        }
      } else{
        if (fileData == "grid") {
        setAumEquModel([])
        } else {
          toast?.error(res?.message)
        }
      
      }
    } catch (error) {
      console.log(error);
    }
    finally{
      setLoader(false);
      setScrollLoader(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    }
    
  };

  const onHide = () => {
    setShowModal(false);
    setPage(1);
    setAumEquModel([]);
    setScrollLoader(false);
  };

  const handleViewClick = (column, duration) => {
    if (column === "total") return;

    const seg = column === "mf" ? "MF" : "EQ";

    setDuration(duration);
    setSegment(seg);
    setShowModal(true);

    setPage(1);
    setAumEquModel([]);
    setScrollLoader(false);
    setLoader(true);

    getAumSnapshotEquityModel(duration, seg, 1);
  };

  const handleScroll = () => {
    if (showModal == true) {
      const a = document.querySelector("#aum-equ");
      if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
        getAumSnapshotEquityModel(duration, segment, page + 1);
      }
    } else {
      setPage(1);
    }
  };

  const generateOverallTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].aum = rows[column].aum || 0;
      rows[column].aumExist = rows[column].aumExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {/* {flag == true ? ( */}
          <th className="text-left first-col"> {rowLabels[index]}</th>
          {/* ) : (
            <></>
          )} */}
          <td
            key={index}
            className="snapshot-table-column overall-aum overall-aum-new"
            onClick={() => handleViewClick(column, "YESTERDAY")}
            // onClick={() => handleViewClick(column, flag)}
          >
            <>
              {/* <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              /> */}
              <>
                {columnValues.aum == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.aum, 1)}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.aumExist == 0
                  ? "text-muted"
                  : columnValues.aumExist < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.aumExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.aumExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>
        </tr>
      );
    });
  };

  const handleSnapshotDuration = (e) => {
    setModalDuration(e?.target?.value);
  };

  //handle data
  const generateSnapshotTableData = (rows, flag) => {
    return Object.keys(rows).map((column, index) => {
      const columnValues = rows[column];
      rows[column].aum = rows[column].aum || 0;
      rows[column].aumExist = rows[column].aumExist || 0;
      rows[column].chg = rows[column].chg || 0;
      rows[column].chgper = forToFix(rows[column].chgper) || 0;

      // rows[column].chgper=  rows[column].chgper.toFixed(2) || (rows[column].chgper).toFixed(2) ;

      return (
        <tr key={index} className="snapshot-table-row snapshot-body">
          {/* {flag == true ? ( */}
          <th className="text-left  first-col"> {rowLabels[index]}</th>
          {/* ) : (
            <></>
          )} */}

          <td
            className="snapshot-table-column overall-aum overall-aum-new"
            onClick={() => handleViewClick(column, flag)}
          >
            <>
              {/* <img
                src={
                  columnValues.chg === 0
                    ? ""
                    : columnValues.chg < 0
                    ? Lowarrow
                    : UpArrow
                }
                alt=""
              /> */}
              <>
                {/* <a
                  className="overall-revenue"
                  onClick={() => handleViewClick(column, "Overall")}
                > */}
                {columnValues.aum == undefined || null
                  ? "0"
                  : numDifferentiationWithoutSymbol(columnValues.aum)}
                {/* </a> */}
              </>
            </>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.aumExist == 0
                  ? "text-muted"
                  : columnValues.aumExist < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.aumExist == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.aumExist)}
            </span>
          </td>
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chg == 0
                  ? "text-muted"
                  : columnValues.chg < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chg == undefined || null
                ? "0"
                : numDifferentiationWithoutSymbol(columnValues.chg)}
            </span>
          </td>
          {/* <br /> */}
          <td className="snapshot-table-column">
            <span
              className={
                columnValues.chgper == 0
                  ? "text-muted"
                  : columnValues.chgper < 0
                    ? "red-new-txt"
                    : "green-new-text"
              }
            >
              {columnValues.chgper == undefined || null
                ? "0"
                : columnValues.chgper}{" "}
              %
            </span>
          </td>

          {/* {Object.keys(columnValues).map((value, index) => {
            return (
              <td key={index} className="snapshot-table-column">
                {index == 0 ? (
                  <img
                    src={
                      columnValues[value] === 0
                        ? ""
                        : columnValues[value] < 0
                        ? Lowarrow
                        : UpArrow
                    }
                    alt=""
                  />
                ) : (
                  ""
                )}
                {columnValues[value] == undefined || null
                  ? "0"
                  : columnValues[value]}
              </td>
            );
          })} */}
        </tr>
      );
    });
  };

  const getAumMFDataModel = async (
    fileData = "grid",
    pageSize = 1
  ) => {
    setMfLoader(true)
    let payloadValue = {
      pageSize: pageSize,
      pageNo: mfPage,
      Duration: modalDuration,
      fileType: fileData,
      clientCode: clCodeMf
    };
    console.log(payloadValue, "payloadValue88");
    
    let encPayload = AESEncryption(payloadValue);

    try {
      const getAumEquity = await axios.post(
        DASHBOARD_DEFAULT.AumMFDetails,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
        
      );
      const response = ApiResDecrypt(getAumEquity?.data);

      const res = response.data;
      if (res) {
        if (showModal == true) {
          if (fileData == "grid") {
            setAumMfData((prev) => {
              return [...prev, ...res.fundList];
            });
          } 
          
        } else {
          setAumMfData(res.eq || res.fundList);
        }
      }
    } catch (error) {
      console.log(error);
    } finally{
      setMfLoader(false);
    }
  };

  useEffect(()=>{
    if(clCodeMf){
      getAumMFDataModel()
    }
  }, [clCodeMf]);

  const handleToggle = (clientCode) => {
  setExpandedRow(prev => prev === clientCode ? null : clientCode);
  setClCodeMf(clientCode);
};

console.log(aumMfData, modalDuration, "aumMfData");


  const showAumeEquModal = (aumEquModel) => {
    return (
      aumEquModel &&
      aumEquModel.map((info, key) => {
         const isOpen = expandedRow === info.clientCode;

        return (
          <>
          <tr key={key}>
            <td className="c-code accordion-mf"> 
                {segment === "MF" && (
                <span
                  className="toggle-btn"
                  onClick={() => handleToggle(info.clientCode)}
                  style={{ cursor: "pointer", marginRight: "8px" }}
                >
                  {isOpen ? <img src={minusCircle} alt="minusCircle"/> : 
                  <img src={addCircle} alt="addCircle" />}
                </span>
              )}
              <span className="code-color">{info.clientCode}</span>
            </td>
            <td>{checkEmpty(info?.clientName) ? "-" : info?.clientName}</td>
            <td>{checkEmpty(info?.holdVal) ? "-" : info?.holdVal}</td>
          </tr>

          {isOpen && (
            <tr>
              <td colSpan="3">
                {mfLoader ? (
                   <div className="loader-alignment">
                      <Loader />
                  </div>
                ) : (
                  <table className="inner-table">
                    
                    <>
                    <thead>
                      <tr>
                        <th>Scheme</th>
                        <th>Current Value</th>
                        <th>Invested Value</th>
                        <th>XIRR</th>
                      </tr>
                    </thead>
                    <tbody className="mf-table-body">
                      <>
                      {aumMfData?.slice(0, 4).map((item, i) => (
                        <tr key={i}>
                          <td>{item?.schName}</td>
                          <td>{item?.currVal}</td>
                          <td>{item?.invVal}</td>
                          <td 
                          style={{
                            color:
                              item?.xirr === 0
                                ? "#6c757d"
                                : item?.xirr < 0
                                  ? "#e60000"
                                  : "#009900"
                            }}>{item?.xirr}%</td>
                        </tr>
                      ))}
                      </>
                    </tbody>

                    <div className="mf-view-btn">
                        <button type="button">
                          <a
                            className="code-color"
                            href="/client-dashboard"
                            onClick={() => {
                              goToClientDashboard(info.clientCode, "");
                              getTabStatus("");
                            }}
                          > 
                          VIEW ALL
                          </a>
                          <img src={arrow} alt="arrow-icon" />
                        </button>
                      </div>
                      </>
                  </table>
                )}
              </td>
            </tr>
          )}

          </>
        );
      })
    );
  };

  const handleFileType = (e) => {
    if (e.target.value) {
      props.handleOnClickSnapFileType(e.target.value, "AUM");
    }
  };

  return (
    <div className="snapshot-detail-block revenue-detail aum-report">
      <div className="card-title mb-0 aum-title">
        <span>{props.title}</span>

        <div className="wrap-modal-header">
          <div className="filter-options">
            {/* <!-- dropdown --> */}
            <div className="new-dropdown">
              <Form.Select
                size="lg"
                aria-label="Default select example"
                onChange={(e) => handleSnapshotDuration(e)}
              >
                <option value="yesterday">{Constants.Yesterday}</option>
                <option value="weekly">{Constants.Current_Week}</option>
                <option value="monthly">{Constants.Current_Month}</option>
                <option value="yearly">{Constants.Current_Year}</option>

                {/* <option value="Overall">Overall</option> */}
              </Form.Select>
            </div>
          </div>
          <div className="generate-btn-wrapper mt-0">
            <button
              className="generate-btn excel1 text-green new-excel-btn"
              value="excel"
              onClick={(e) => handleFileType(e)}
            >
              {props?.buttonLoader?.excel ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-excelsvg"></span>
                  Excel
                </>
              )}
            </button>
            <button
              className="generate-btn pdf1 txt-purple new-pdf-btn"
              value="pdf"
              onClick={(e) => handleFileType(e)}
            >
              {props?.buttonLoader?.pdf ? (
                <SmallLoader />
              ) : (
                <>
                  <span className="icon-pdfsvg"></span> PDF
                </>
              )}
            </button>
          </div>

          <button
            type="button"
            className="btn-close snapshot-close-btn"
            aria-label="Close"
            onClick={() => setShowAumModal(false)}
          >
            <span className="icon-close"></span>
          </button>
        </div>
      </div>

      <div className="snapshot-table scroll-table snapshot-new-table">
        <table className="table tabel-level1">
          <tr>
            {modalDuration === "yesterday" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Yesterday}
                    <span> {Constants.Compare_Yesterday}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {aumLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                              {/* {Constants.Yesterday}
                      <br />
                      <span>{Constants.Compare_Yesterday}</span> */}
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateOverallTableData(revenueTable, true)}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : modalDuration === "weekly" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Week}
                    <span> {Constants.Compare_Week}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {aumLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                          {/* <tr className="snapshot-head">
                    <th scope="col" className=" first-col"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr> */}
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(revenueTable, "WEEKLY")}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : modalDuration === "monthly" ? (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Month}
                    <span> {Constants.Compare_Month}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {aumLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(
                                revenueTable,
                                "MONTHLY",
                              )}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            ) : (
              <>
                <div>
                  <th
                    colSpan="3"
                    scope="col"
                    className="col-width-tab duration-title"
                  >
                    {Constants.Current_Year}
                    <span> {Constants.Compare_Year}</span>
                  </th>
                </div>
                <td className="for-width pb-0">
                  <table className="table table-level2">
                    {aumLoader === true ? (
                      <div className="loader-alignment">
                        <Loader />
                      </div>
                    ) : (
                      <>
                        <thead>
                          <tr className="snapshot-head">
                            <th
                              colSpan="3"
                              scope="col"
                              className="col-width-tab text-center snapshot-title"
                            >
                              Segment
                              {/* {Constants.Current_Year}
                      <br />
                      <span>{Constants.Compare_Year}</span> */}
                            </th>
                            <th scope="col">{firstColumnTitle}</th>
                            <th scope="col">{Constants.Previous}</th>
                            <th scope="col">{Constants.Change}</th>
                            <th scope="col">{Constants.Change_Perc}</th>
                          </tr>
                          {/* <tr className="snapshot-head">
                    <th scope="col" className="first-col"></th>
                    <th scope="col">{firstColumnTitle}</th>
                    <th scope="col">{Constants.Previous}</th>
                    <th scope="col">{Constants.Change}</th>
                    <th scope="col">{Constants.Change_Perc}</th>
                  </tr> */}
                        </thead>
                        <tbody>
                          {revenueTable == null || undefined
                            ? handleifTableEmpty(true)
                            : generateSnapshotTableData(revenueTable, "YEARLY")}
                        </tbody>
                      </>
                    )}
                  </table>
                </td>
              </>
            )}
          </tr>
        </table>
      </div>

      <Modal
        show={showModal}
        // onHide={() => setShowModal(false)
        // }
        onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="inactive-modal setting-model snapshot-modal"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="mb-4 modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <img
              src={backIcon}
              alt="back-icon"
              onClick={() => setShowModal(false)}
            />
            <p className="title-snapshot">{Constants.AUM_Snapshot}
              <span style={{fontSize: "12px", color: "#666666", marginLeft: "7px"}}>({segment === "MF" ? "Mutual Funds" : "Equity"})</span>
            </p>
          </Modal.Title>

          <div className="wrap-buttons-modal">
            <div className="generate-btn-wrapper">
              <button
                className="generate-btn text-green new-excel-btn"
                value="excel"
                onClick={(e) =>
                  getAumSnapshotEquityModel(
                    duration,
                    segment,
                    -1,
                    e.target.value,
                  )
                }
              >
                {smallLoaderExcel ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    {"Excel"}
                  </>
                )}
              </button>
              <button
                className="generate-btn txt-purple new-pdf-btn"
                value="pdf"
                onClick={(e) =>
                  getAumSnapshotEquityModel(
                    duration,
                    segment,
                    -1,
                    e.target.value,
                  )
                }
              >
                {smallLoaderPdf ? (
                  <SmallLoader />
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span> {"PDF"}
                  </>
                )}
              </button>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onHide}
            >
              <span className="icon-close"></span>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive scroll-table model-top-active-table snapshot-detail-table aum-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : aumEquModel && aumEquModel.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      CLIENT CODE</th>
                    <th>CLIENT NAME</th>
                    <th>HOLDING VALUE</th>
                  </tr>
                </thead>

                <tbody id="aum-equ" onScroll={handleScroll}>
                  {showAumeEquModal(aumEquModel)}
                  {scrollLoader && (
                  <div className="d-flex justify-content-center ">
                    <LoaderForSearch />
                  </div>
                )}
                </tbody>
                
              </table>
            ) : (
              noDataFound()
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default React.memo(AumSnapshot);
